const STATUS = {
    ACTIVE: 1,
    SCHEDULED: 2,
    EXPIRED: 3,
    CANCELLED: 0
}

export const STATUS_LABEL = {
    [STATUS.ACTIVE]: {
        label: 'Active',
        color: 'green',
        status: STATUS.ACTIVE
    },
    [STATUS.SCHEDULED]: {
        label: 'Scheduled',
        color: 'orange',
        status: STATUS.SCHEDULED
    },
    [STATUS.EXPIRED ]: {
        label: 'Expired',
        color: 'default',
        status: STATUS.EXPIRED
    },
    [STATUS.CANCELLED]: {
        label: 'Cancelled',
        color: 'red',
        status: STATUS.CANCELLED
    }
}